import { WorkQueueDetails } from '@core/services/work-queue/work-queue.model';
import { Action } from '@ngrx/store';

export enum lenderRemediationQueueActionTypes {
  LOAD_LENDERREMEDIATIONQUEUE = '[LENDERREMEDIATIONQUEUE] Load LenderRemediationQueue',
  LOAD_LENDERREMEDIATIONQUEUE_SUCCESS = '[LENDERREMEDIATIONQUEUE] Load LenderRemediationQueue Success',
  LOAD_LENDERREMEDIATIONQUEUE_FAIL = '[LENDERREMEDIATIONQUEUE] Load LenderRemediationQueue Fail',
}

export class LOADLENDERREMEDIATIONQUEUE implements Action {
  readonly type = lenderRemediationQueueActionTypes.LOAD_LENDERREMEDIATIONQUEUE;
  constructor(public payload: number, public queuetype: number, public workqueueStatusId: number, public accountUpdateOptionId: number, public customerFollowUpOptionId: number, public investigationOptionId: number, public insuranceFollowUpOptionId: number) { }
}

export class LOADLENDERREMEDIATIONQUEUESUCCESS implements Action {
  readonly type = lenderRemediationQueueActionTypes.LOAD_LENDERREMEDIATIONQUEUE_SUCCESS;
  constructor(public payload: WorkQueueDetails) { }
}

export class LOADLENDERREMEDIATIONQUEUEFAIL implements Action {
  readonly type = lenderRemediationQueueActionTypes.LOAD_LENDERREMEDIATIONQUEUE_FAIL;
  constructor(public payload: string) { }
}

export type LenderRemediationQueueAction =
  | LOADLENDERREMEDIATIONQUEUE
  | LOADLENDERREMEDIATIONQUEUESUCCESS
  | LOADLENDERREMEDIATIONQUEUEFAIL;
